import { Routes, Route, Navigate } from "react-router-dom";
import { DashboardLayout } from "./layouts/DashboardLayout";
import { LoginPage } from "./pages/Login";
import { HomeBriefPage } from "./pages/HomeBrief";
import { PlacementsPage } from "./pages/Placements";
import { ConfigurationsPage } from "./pages/Configurations";
import { SubstitutionPage } from "./pages/Substitution";
import { FunnelPage } from "./pages/Funnel";
import { AlertsPage } from "./pages/Alerts";
import { ExportsPage } from "./pages/Exports";
import { SettingsPage } from "./pages/Settings";
import { NotFoundPage } from "./pages/NotFound";

/**
 * Top-level routes. Auth gating happens in DashboardLayout — unauthenticated
 * users get bounced to /login.
 */
export function App() {
	return (
		<Routes>
			<Route path="/login" element={<LoginPage />} />
			<Route element={<DashboardLayout />}>
				<Route path="/" element={<HomeBriefPage />} />
				<Route path="/placements" element={<PlacementsPage />} />
				<Route path="/configurations" element={<ConfigurationsPage />} />
				<Route path="/substitution" element={<SubstitutionPage />} />
				<Route path="/funnel" element={<FunnelPage />} />
				<Route path="/alerts" element={<AlertsPage />} />
				<Route path="/exports" element={<ExportsPage />} />
				<Route path="/settings" element={<SettingsPage />} />
			</Route>
			<Route path="/health" element={<HealthCheck />} />
			<Route path="*" element={<NotFoundPage />} />
			<Route path="/index.html" element={<Navigate to="/" replace />} />
		</Routes>
	);
}

function HealthCheck() {
	return (
		<pre style={{ padding: 20 }}>
			{JSON.stringify(
				{ ok: true, service: "aivision-insights-web", version: "v0" },
				null,
				2,
			)}
		</pre>
	);
}
